const Verificaidentita = () => {
  //TODO App atterra su questa pagina con questi parametri:
  // ?app=true&shareCode=XXXX&flowType=1&icmp=lockin_returning_user&placeId=ChIJS9bb5EbafkcRGXr_KOYYU_0&cmsId=51
  // i parametri flowType=1&icmp=lockin_returning_user&placeId=ChIJS9bb5EbafkcRGXr_KOYYU_0&cmsId=51 sono quelli del carrello dinamico
  // share_code è il parametro da mandare a Amdocs per la login

  // Il flusso è:
  // 1) recuperare tutti i parametri da queryString,
  // 2) salvare nel localstorage quelli del carrello dinamico
  // 3) fare la login con Amdocs, ovvero redirect su url configurato su variabile di ambiente NEXT_PUBLIC_CDA_AMD_LOGIN
  // 4) All'url recuperato aggiungere il parametro shareCode in append => &shareCode=XXXX
  // 5) Fare redirect a questo url.
  // 6) Quando finisce la login si tornerà sulla stessa parina di partenza (ES: privati.vodafone.it/privati/verificaidentita) senza parametri
  // 7) A questo punto chiamare la silentLogin e verificare se sono logged. (per esempio vedi sviluppo di U.Vignotto newLogin.hook.ts)
  // 8) Se non sono logged e ho già fatto il flusso, restituisco errore e cancello i parametri nel localstorage
  // 9) Se sono logged recupero i parametri salvati nel localstorage per il carrello e faccio redirect su: privati.vodafone.it/shopping-cart?PARAMETRI_RECUPERATI

  // Il Frontend mostrerà sempre un loader: passare un lottie o svg a <Loading> sotto components (configurare sul cms)

  return <div></div>;
};

export default Verificaidentita;
